import AppContext, {SidebarType} from "../context/AppContext";
import SidebarParticipants from "./sidebar/SidebarParticipants";
import SidebarChat from "./sidebar/SidebarChat";
import React, {useContext} from "react";
import SidebarDeviceSettings from "./sidebar/SidebarDeviceSettings";

export default () => {
  const {
    conferenceStatus,
    sidebar,
  } = useContext(AppContext)

  return (
    <>
      { conferenceStatus.admitted && sidebar === SidebarType.Participants ? (
        <SidebarParticipants/>
      ) : null }

      { conferenceStatus.admitted && sidebar === SidebarType.Chat ? (
        <SidebarChat/>
      ) : null }

      { sidebar === SidebarType.DeviceSettings ? (
        <SidebarDeviceSettings/>
      ) : null }
    </>
  )
}